import React, { useRef, useState } from 'react';
import omit from 'lodash/omit';

import { validateFiles } from '../helpers';
import ModalFileAlert from './ModalFileAlert.jsx';

const FileClick = (props) => {
  const {
    className = 'pos-abs-fill',
    children,
    onFile = () => {},
    maxSize,
    resetOnSelect = false,
  } = props;
  const input = useRef();
  const [alert, setAlert] = useState(false);

  const onChange = (evt) => {
    const { files } = evt.target;
    if ( !files || files.length === 0 ) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.log('[FileClick] onChange', {
        count: files.length,
        names: Array.from(files).map((f) => f.name),
      });
    }

    // check the files' size
    const err = validateFiles(files, { maxSize });

    if (err) {
      setAlert(err);
      return;
    }

    onFile(files);
    if ( resetOnSelect ) {
      evt.target.value = null;
    }
  };

  return (
    <>
      <div
        className={className}
        onClick={(e) => {
          if (e.target !== input.current) {
            e.preventDefault();
            input.current.click();
          }
        }}
      >
        {children}
        <div className="position-relative opacity-0 overflow-hidden">
          <input
            ref={input}
            type="file"
            onChange={onChange}
            onClick={(e) => e.target.value = null}
            className="position-absolute"
            autoComplete="off"
            {...omit(props, [
              'children',
              'onFile',
              'className',
              'maxSize',
              'resetOnSelect',
            ])}
          />
        </div>
      </div>
      {maxSize && (
        <ModalFileAlert
          show={alert}
          onHide={() => setAlert(false)}
          maxSize={maxSize}
        />
      )}
    </>
  );
};

export default FileClick;
